import React from 'react';
import {connect} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './PackagePanel.css';
import ActionMenu from '../../../../components/action-menu/ActionMenu';
import ActionMenuItem from '../../../../components/action-menu/ActionMenuItem';
import ViewIcon from '../../../../components/action-menu/icons/ViewIcon';
import QrIcon from '../../../../components/action-menu/icons/QrIcon';
import ClockRotateIcon from '../../../../components/action-menu/icons/ClockRotateIcon';
import GiftIcon from '../../../../components/action-menu/icons/GiftIcon';
import DeleteIcon from '../../../../components/action-menu/icons/DeleteIcon';
import AuthService from '../../../../services/auth-service/AuthService';
import RemotingService from '../../../../services/remoting-service/RemotingService';
import AddPackagePanel from './AddPackagePanel';
import DateUtil from '../../../../utils/DateUtil';
import GreenSwitch from '../../../../components/switch/GreenSwitch';
import dialog from "../../../../components/dialog/Dialog";
import ConsentFormCode from "../../../consentform/ConsentFormCode";
import confirmAndDeleteDialog from "../../../../components/dialog/ConfirmAndDeleteDialog";
import confirmDialog from "../../../../components/dialog/ConfirmDialog";
import PackageConsentForm from './PackageConsentForm';
import SockJsClient from "react-stomp";
import EnumPackageStatus from './enums/EnumPackageStatus';
import EnumAppointmentType from '../../../appointment/enums/EnumAppointmentType';
import ExtendValidityDialog from './ExtendValidityDialog';

class PackagePanel extends React.Component {

    state = {
        addModalVisible: false,
        packages: []
    };

    componentDidMount() {
        this.retrievePatientPackages();
    }

    retrievePatientPackages = () => {
        RemotingService.getRemoteCall(`api/patients/${this.props.patientId}/packages`, null,
            packages => this.setState({
                packages: packages.sort((a, b) => a.isActiveMode === b.isActiveMode ? 0 : a.isActiveMode ? -1 : 1)
            })
        );
    }

    refreshScreen = () => {
        setTimeout(() => window.location.reload(false), 1000);
    }

    showDetailModal() {
        this.setState({addModalVisible: true});
    }

    closeDetailModal = () => {
        this.setState({addModalVisible: false});
    }

    render() {
        const items = this.state.packages;

        return (
            <div className="card sponsorship-panel">
                <SockJsClient
                    url={RemotingService.getApiBaseUrl() + "websocket"}
                    topics={["/topic/package-form/" + this.props.patientId]}
                    onMessage={this.refreshScreen}
                    ref={client => this.clientRef = client}
                />
                <div className="card-header">
                    <div className="card-header-title">
                        <strong style={{verticalAlign: "middle"}}>Package</strong>
                    </div>
                    <div className="card-header-actions">
                        {((this.props.editable || AuthService.isProvider()) && AuthService.userHasAuthority("UPDATE_PATIENT_PACKAGE")) &&
                            <button type="button" className="btn btn-primary btn-sm"
                                    onClick={() => this.showDetailModal()}>
                                Add Package
                            </button>
                        }
                    </div>
                </div>
                <div className="card-body line-wrapper small-font">
                    <div className="row d-flex flex-nowrap">
                        <div className="package-col-id package-text-left">ID</div>
                        <div className="package-col-status package-text-left">Status</div>
                        <div className="package-col-name package-text-left">Name</div>
                        <div className="package-col-description package-text-left">Description</div>
                        <div className="package-col-type package-text-left">Type</div>
                        <div className="package-col-amount package-text-left">Amount</div>
                        <div className="package-col-balance package-text-left">Balance</div>
                        <div className="package-col-percentage package-text-center">Discount %</div>
                        <div className="package-col-tax-percentage package-text-center">Tax %</div>
                        <div className="package-col-tax-amount package-text-center">Tax Amount</div>
                        <div className="package-col-sessions package-text-left">No of Sessions</div>
                        <div className="package-col-used-sessions package-text-left">Used Sessions</div>
                        <div className="package-col-first-price package-text-left">First Session Price</div>
                        <div className="package-col-price-per-session package-text-left">Price Per Session</div>
                        <div className="package-col-validity package-text-left">Validity</div>
                        <div className="package-col-actions package-text-left">Actions</div>
                        <div className="package-col-active package-text-left">Active</div>
                    </div>
                    <hr/>
                    {(items && items.length) ?
                        <div className="row">
                            <PackageDetailPanel patientId={this.props.patientId}
                                                sponsorData={this.state.sponsorData}
                                                handlePackageUpdate={() => {
                                                    this.retrievePatientPackages()
                                                }}
                                                package={items[0]}
                                                addModalVisible={this.state.addModalVisible}
                                                closeModal={this.closeDetailModal}/>
                            {items.length > 1 ?
                                <FontAwesomeIcon
                                    className={"angle-double-icon"}
                                    icon={["fa", `angle-double-${this.state.panelExpanded ? 'up' : 'down'}`]}
                                    onClick={() => this.setState({panelExpanded: !this.state.panelExpanded})}/> : null
                            }
                        </div>
                        :
                        <div className="row">
                            <div className="col-12">
                                No package info found.
                            </div>
                        </div>
                    }
                </div>
                {
                    items && items.length && items.length > 1 ?
                        <div
                            className={`card-body small-font text-right expandable ${this.state.panelExpanded ? 'expanded' : ''}`}>
                            {items.map((item, inx) => {
                                if (inx === 0) return;
                                return (
                                    <div className="row" key={'sponsorship-detail-row-' + inx}>
                                        <PackageDetailPanel key={'sponsorship-detail-panel-' + inx}
                                                            patientId={this.props.patientId}
                                                            handlePackageUpdate={() => {
                                                                this.retrievePatientPackages()
                                                            }}
                                                            package={item} index={inx}/>
                                    </div>
                                )
                            })}
                        </div> : null
                }
                {
                    this.state.addModalVisible &&
                    <AddPackagePanel
                        visible={this.state.addModalVisible}
                        patientId={this.props.patientId}
                        retrievePatientPackages={() => this.retrievePatientPackages()}
                        closeModal={this.closeDetailModal}
                    />
                }
            </div>
        );
    }
}

class PackageDetail extends React.Component {

    state = {
        addModalVisible: false,
        consentFormVisible: false
    };

    componentDidMount() {
        this.setState({addModalVisible: this.props.addModalVisible});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.addModalVisible !== this.props.addModalVisible) {
            this.setState({addModalVisible: this.props.addModalVisible});
        }
    }

    deletePackage = (packageItem) => {
        confirmAndDeleteDialog(
            "Delete Package",
            "Are you sure you want to delete this package? This action cannot be undone.",
            `api/patients/${this.props.patientId}/packages/${packageItem.id}`,
            () => { this.props.handlePackageUpdate(); },
            "Delete",
            "Cancel"
        );
    }

    toggleIsActive = (id, isActiveMode) => {
        RemotingService.postRemoteCall(`api/patients/${this.props.patientId}/packages/${id}/activate`, null, (response) => {
            this.props.handlePackageUpdate();
        });
    }

    generateTabletCode = (id) => {
        RemotingService.postRemoteCall(
            "api/consent-form/code",
            {formType: "PACKAGE_CONSENT_FORM", patientId: this.props.patientId, creditId: id},
            (response) => {
                dialog({
                    style: {width: 450, height: 150},
                    component: <ConsentFormCode code={response.code} duration={response.durationInMinutes} formName={"Credit Consent Form"}/>,
                    disableBackdropClick: false
                });
            }
        );
    }

    refund = (id) => {
        confirmDialog(
            "Refund Package",
            "Would you like to refund the selected package?",
            () => {
                RemotingService.postRemoteCall(`api/patients/${this.props.patientId}/packages/${id}/refund`, null, (response) => {
                    this.props.handlePackageUpdate();
                });
            }
        );
    }

    // Show extend validity dialog
    extendValidity = (packageItem) => {
        dialog({
            component: <ExtendValidityDialog
                packageItem={packageItem}
                handlePackageUpdate={this.props.handlePackageUpdate}
            />,
            style: {width: 520, minHeight: 400},
            disableBackdropClick: false
        });
    }

    // View package consent form using existing package.form data
    view = () => {
        this.setState({consentFormVisible: true});
    }

    // Close package consent form
    closeConsentForm = () => {
        this.setState({consentFormVisible: false});
    }

    // Handle consent form completion (read-only mode, so just close)
    handleConsentFormComplete = (formData) => {
        this.closeConsentForm();
    }

    render() {
        const item = this.props.package;
        // const coverage = sponsorship && this.getCoverage(sponsorship);

        return (
            <>
                {item &&
                    <>
                        <div className="package-col-id package-text-left">
                            {item.packageId}
                        </div>
                        <div className="package-col-status package-text-left">
                            {EnumPackageStatus[item.status] || item.status}
                        </div>
                        <div className="package-col-name package-text-left">
                            {item.name || '-'}
                        </div>
                        <div className="package-col-description package-text-left">
                            {item.description || '-'}
                        </div>
                        <div className="package-col-type package-text-left">
                            {EnumAppointmentType[item.type]?.name || item.type}
                        </div>
                        <div className="package-col-amount package-text-center">
                            {item.amount}
                        </div>
                        <div className="package-col-balance package-text-center">
                            {item.balance}
                        </div>
                        <div className="package-col-percentage package-text-center">
                            {item.discountPercentage} <small>%</small>
                        </div>
                        <div className="package-col-tax-percentage package-text-center">
                            {item.taxPercentage} <small>%</small>
                        </div>
                        <div className="package-col-tax-amount package-text-center">
                            {item.taxAmount}
                        </div>
                        <div className="package-col-sessions package-text-center">
                            {item.sessionCount}
                        </div>
                        <div className="package-col-used-sessions package-text-center">
                            {item.usedSessionCount}
                        </div>
                        <div className="package-col-first-price package-text-center">
                            {item.firstSessionPrice}
                        </div>
                        <div className="package-col-price-per-session package-text-center">
                            {item.pricePerSession}
                        </div>
                        <div className="package-col-validity package-text-left">
                            {DateUtil.formatDate(item.validUntil)}
                        </div>
                        <div className="package-col-actions package-text-right">
                            <ActionMenu id="packagePanelActionMenu">
                                <ActionMenuItem icon={<ViewIcon/>} onClick={() => {
                                    this.view()
                                }} text={"View"}/>
                                <ActionMenuItem icon={<QrIcon/>} onClick={() => {
                                    this.generateTabletCode(item.id)
                                }} text={"Generate Tablet Code"}
                                                disabled={!["PENDING", "PENDING_SIGNATURE", "ACTIVE", "EXPIRED"].includes(item.status)}
                                />
                                <ActionMenuItem icon={<GiftIcon/>} onClick={() => {
                                    this.refund(item.id)
                                }} text={"Get Refund"}
                                                disabled={item.status === "REFUNDED"}
                                />
                                <ActionMenuItem icon={<ClockRotateIcon/>} onClick={() => {
                                    this.extendValidity(item)
                                }} text={"Extend Validity"}
                                                disabled={item.status === "REFUNDED"}
                                />
                                <ActionMenuItem icon={<DeleteIcon/>} onClick={() => {
                                    this.deletePackage(item)
                                }} text={"Delete"}
                                                disabled={!(item.status === "PENDING_PAYMENT" || item.status === "PENDING")}
                                />
                            </ActionMenu>
                        </div>
                        <div className="package-col-active package-text-right">
                            <GreenSwitch checked={item.isActiveMode}
                                         onChange={(value) => this.toggleIsActive(item.id, value)}
                                         disabled={item.status === "REFUNDED" || item.status === "COMPLETED"}
                            />
                        </div>
                    </>
                }
                {this.state.consentFormVisible && (
                    <PackageConsentForm
                        show={this.state.consentFormVisible}
                        close={this.closeConsentForm}
                        onFormComplete={this.handleConsentFormComplete}
                        form={{
                            ...this.props.package.form,
                            packageId: this.props.package.id
                        }}
                        patientId={this.props.patientId}
                        language="English"
                        readOnly={true}
                        fullScreen={false}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.authentication.user
    };
};

const PackageDetailPanel = connect(mapStateToProps)(PackageDetail)

export default PackagePanel;
